import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './Hero.css';
import logo from '../assets/logoblanco-def.png';
import { useCart } from '../context/CartContext';
import { useNavbarScroll } from '../hooks/useNavbarScroll';
import MobileNav from './MobileNav';

const Hero = () => {
  const { toggleCart, getTotalItems } = useCart();
  const [navReady, setNavReady] = useState(false);
  const [heroContentReady, setHeroContentReady] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const { hidden: navbarHidden, compact: navbarCompact } = useNavbarScroll();
  const navigate = useNavigate();

  useEffect(() => {
    const t1 = setTimeout(() => setNavReady(true), 80);
    const t2 = setTimeout(() => setHeroContentReady(true), 350);
    return () => {
      clearTimeout(t1);
      clearTimeout(t2);
    };
  }, []);

  // MobileNav already handles body overflow lock

  return (
    <div className={`hero-section${heroContentReady ? ' hero-content-ready' : ''}`}>
      <nav className={`navbar navbar-expand-lg navbar-dark${navReady ? ' nav-ready' : ''}${navbarHidden ? ' navbar-hidden' : ''}${navbarCompact ? ' navbar-compact' : ''}${mobileMenuOpen ? ' navbar-mobile-open' : ''}`}>
        <div className="container-fluid px-4">
          <div className="navbar-nav navbar-nav-left me-auto">
            <button className="nav-link" onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}>INICIO</button>
            <button className="nav-link" onClick={() => navigate('/equipo')}>EQUIPO</button>
            <button className="nav-link" onClick={() => navigate('/bodegas')}>BODEGAS</button>
          </div>

          <a className="navbar-brand mx-auto" href="#home" onClick={(e) => {
            e.preventDefault();
            navigate('/');
          }}>
            <img src={logo} alt="Rosés Wines" className="logo" />
          </a>

          <div className="navbar-nav navbar-nav-right ms-auto">
            <button className="nav-link" onClick={() => navigate('/historia')}>HISTORIA</button>
            <button className="nav-link" onClick={() => navigate('/kit-de-marca')}>KIT DE MARCA</button>
            <button className="nav-link" onClick={() => navigate('/#tienda')}>TIENDA</button>
            <button className="nav-link cart" onClick={toggleCart}>
              <span className="cart-icon">🛒</span>
              {getTotalItems() > 0 && (
                <span className="cart-badge">{getTotalItems()}</span>
              )}
            </button>
          </div>

          <button
            type="button"
            className="navbar-toggler hamburger-btn"
            onClick={() => setMobileMenuOpen((o) => !o)}
            aria-expanded={mobileMenuOpen}
            aria-label="Menú"
          >
            <span className="hamburger-line" />
            <span className="hamburger-line" />
            <span className="hamburger-line" />
          </button>
        </div>
      </nav>

      <MobileNav open={mobileMenuOpen} onClose={() => setMobileMenuOpen(false)} />

      <div className="hero-content">
        <div className="container text-center hero-content-inner">
          <p className="hero-subtitle">Desde 1977</p>
          <h1 className="hero-title">
            EXPLORA NUESTRA<br />
            SELECCIÓN DE VINOS
          </h1>
          <p className="hero-description">¡Visitá nuestra tienda online!</p>
          
          <button 
            className="scroll-to-shop-btn"
            onClick={() => {
              document.getElementById('tienda')?.scrollIntoView({ 
                behavior: 'smooth',
                block: 'start'
              });
            }}
          >
            EXPLORAR TIENDA
          </button>
        </div>
      </div>
    </div>
  );
};

export default Hero;
